export default {
  FEEDBACK: 'FEEDBACK',
  IAP_PACKAGE: 'IAP_PACKAGE',
  DARK_MODE: 'DARK_MODE',
  TOKEN: 'TOKEN',
  ACCOUNT_LIST: 'ACCOUNT_LIST',
  USER_NAME: 'USER_NAME',
  USER_PASSWORD: 'USER_PASSWORD',
  STAFF_USER_NAME: 'STAFF_USER_NAME',
  STAFF_USER_PASSWORD: 'STAFF_USER_PASSWORD',
  USING_OFFLINE: 'USING_OFFLINE',
  HAS_OFFLINE_DATA: 'HAS_OFFLINE_DATA',
  SHOW_SYNC_OFFLINE: 'SHOW_SYNC_OFFLINE',
  HIDE_GUIDE: 'HIDE_GUIDE',
  BILL_PRINTER_SETTING: 'BILL_PRINTER_SETTING',
  BILL_PRINTER: 'BILL_PRINTER',
  LABEL_PRINTER: 'LABEL_PRINTER',
  PRINTER_ADDRESS: 'PRINTER_ADDRESS',
  PRINTER_NAME: 'PRINTER_NAME',
  PRINTER_DISPLAY_NAME: 'PRINTER_DISPLAY_NAME',
  PRINTER_SPACING_BOTTOM: 'PRINTER_SPACING_BOTTOM',
  PRINTER_TYPE: 'PRINTER_TYPE',
  PRINTER_METHOD: 'PRINTER_METHOD',
  PRINTER_SIZE: 'PRINTER_SIZE',
  PRINTER_THRESHOLD: 'PRINTER_THRESHOLD',
  PRINTER_SPEED: 'PRINTER_SPEED',
  ORDER_SETTING: 'ORDER_SETTING',
  STAFF_ORDER_STATUS: 'STAFF_ORDER_STATUS',
  BILL_SETTING: 'BILL_SETTING',
  CURRENT_WAREHOUSE: 'CURRENT_WAREHOUSE',
  DRAFT_ORDERS: 'DRAFT_ORDERS',
  LIST_PRODUCTS: 'LIST_PRODUCTS',
  LIST_CUSTOMERS: 'LIST_CUSTOMERS',
  LIST_UNIT: 'LIST_UNIT',
  HAS_LOCAL_DATA: 'HAS_LOCAL_DATA',
  LAST_RENEW_WARNING: 'LAST_RENEW_WARNING',
  SHORTCUT: 'SHORTCUT',
  EVENT_SHOW_DATE: 'EVENT_SHOW_DATE',
  LIST_CATEGORIES: 'LIST_CATEGORIES',
  DRAFF_ORDER_LIST: 'DRAFF_ORDER_LIST',
  PRODUCT_SORT_TYPE: 'PRODUCT_SORT_TYPE',
  FONT_SIZE_TYPE: 'FONT_SIZE_TYPE',
  ADS_EVENT_COUNT: 'ADS_EVENT_COUNT',
  PRINT_BARCODE_SETTING: 'PRINT_BARCODE_SETTING',
  LAST_PROMOTION_ID: 'LAST_PROMOTION_ID',
  SHOW_INTRO: 'SHOW_INTRO',
  HOST_TYPE: 'HOST_TYPE',
  DEBT_HIDE_PRODUCT: 'DEBT_HIDE_PRODUCT',
  DEBT_TYPE: 'DEBT_TYPE',
  DEBT_VIETQR: 'DEBT_VIETQR',
  COUNTRY_CODE: 'COUNTRY_CODE',
  LOCAL_SETTING: 'LOCAL_SETTING'
};
